import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

/**
 * Dialog for overriding the base status of a subscription.
 * Use in admin subscription detail.
 */
export default function OverrideStatusDialog({
  open,
  onClose,
  value,
  onValueChange,
  onConfirm,
  loading = false,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Override Base Status</DialogTitle>
      <DialogContent dividers>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Manually changing the base status can cause it to diverge from Squarespace. Use only when you need to correct a sync issue or override the automatic status.
        </Alert>
        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={value}
            label="Status"
            onChange={(e) => onValueChange(e.target.value)}
          >
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="processing">Processing</MenuItem>
            <MenuItem value="cancelled">Cancelled</MenuItem>
            <MenuItem value="expired">Expired</MenuItem>
            <MenuItem value="paused">Paused</MenuItem>
            <MenuItem value="locked">Locked</MenuItem>
          </Select>
        </FormControl>
        {value === "processing" && (
          <Alert severity="info" sx={{ mt: 2 }}>
            Syncing with Squarespace. Override to active, cancelled, or another status if the sync is stuck.
          </Alert>
        )}
        {value === "locked" && (
          <Alert severity="info" sx={{ mt: 2 }}>
            This subscription is locked to prevent changes on the Portal site. Users will not be able to cancel, reactivate, or change auto-renew.
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm} disabled={loading}>
          {loading ? "Saving…" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
